import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const Footer = () => {
  return (
    <div className="container-footer" id="Contacto">
      <div className="container-fluid site-footer-wrapper">
        <img className="footer-lines" src="https://s3media.clubpremier.info/clubpremierstyleguide/amstyleguideinfo/images/lineas-footer.png" alt="" />
        <div className="row p-15">
          <div className="container site-footer">
            <div className="row">
              <div className="col-md-3 contact-info">
                <h5 id="footer-contact-info">Llámanos</h5>
                <div className="row">
                  <div className="col-6">República Mexicana</div>
                  <div className="col-6">
                    <a href="tel:525515194040">(52 55) 1519 4040</a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">Estados Unidos</div>
                  <div className="col-6">
                    <a href="tel:18554122650">(1) 855 412 2650</a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">España</div>
                  <div className="col-6">
                    <a href="tel:900995282">900 995 282</a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">Chile</div>
                  <div className="col-6">
                    <a href="tel:56225994378">(+56-2) 2599 4378</a>
                    <div className="text-white">Opción 4</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">Resto del mundo</div>
                  <div className="col-6">
                    <a href="tel:80080056800">800 800 56800</a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 other-info">
                <h5>Envíanos un correo</h5>
                <p><a href="mailto:soporte.rewards@aeromexico.com">soporte.rewards@aeromexico.com</a></p>
                <p>Horarios de atención de lunes a domingo de 08:00 a 22:00 horas (GMT -5)</p>
                <h5>Descarga nuestra app</h5>
                <div className="row">
                  <div className="col-auto col-12 col-md-6 d-flex">
                    <p>
                      <a href="https://play.google.com/store/apps/details?id=com.clubpremier.loyalty.android">
                        <img src="https://s3media.aeromexicorewards.com/club_premier/img/footer/google-play-badge.svg" alt="Google Play" rel="noopener nofollow" target="_blank" />
                      </a>
                    </p>
                    <p className="ml-5 ml-md-0">
                      <a href="https://itunes.apple.com/mx/app/club-premier/id592240448?mt=8">
                        <img src="https://s3media.aeromexicorewards.com/club_premier/img/footer/app-store-badge.svg" alt="App Store" rel="noopener nofollow" target="_blank" />
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 text-md-left other-links">
                <p>
                  <a href="https://www.aeromexicorewards.com/mx/acerca-de-club-premier/">Acerca de Aeroméxico Rewards</a>
                </p>
                <p>
                  <a href="/">Programa de Integridad y Cumplimiento</a>
                </p>
                <p>
                  <a href="https://amfacturacion.aeromexico.com/?_ga=2.263481548.1302231669.1535385513-385790940.1535385513">Facturación Electrónica</a>
                </p>
                <p>
                  <a href="/" className="font-weight-bold ft-12">Más amigos, más Puntos</a>
                </p>
                <p>
                  <a href="/">Obtén 20% más Puntos Aeroméxico Rewards por las acumulaciones de tus amigos.</a>
                </p>
              </div>
              <div className="col-md-3 text-md-left social-links">
                <h5>
                  <img className="logo" src="https://s3media.clubpremier.info/clubpremierstyleguide/amstyleguideinfo/images/am-rewards-white.svg" alt="Aeroméxico Rewards" />
                </h5>
                <div className="social-buttons">
                  <a className="social-link" href="https://www.facebook.com/clubpremiermexico">
                    <span className="fab fa-facebook-f" />
                  </a>
                  <a className="social-link" href="https://twitter.com/clubpremier_mx">
                    <span className="fab fa-twitter" />
                  </a>
                  <a className="social-link" href="https://www.instagram.com/clubpremier/">
                    <span className="fab fa-instagram" />
                  </a>
                  <a className="social-link" href="https://api.whatsapp.com/send?phone=5215515194040&amp;text=Hola&amp;source=&amp;data=">
                    <span className="fab fa-whatsapp" />
                  </a>
                </div>
                <div>
                  <a className="btn btn-primary-dark btn-size-override" href="https://member.aeromexicorewards.com/registro">Inscríbete</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-tangaroa">
        <Row className="p-15">
          <Container>
            <Row>
              <Col xs={12} lg={6} xl={6} className="text-center text-lg-left">
                <small className="text-white">© 2022 Aeroméxico Rewards. Todos los Derechos Reservados.</small>
              </Col>
              <Col xs={12} lg={6} xl={6} className="text-center text-lg-right">
                <small>
                  <a className="text-white" href="https://www.aeromexicorewards.com/mx/acerca-de-club-premier/terminos-y-condiciones/">Términos y Condiciones </a>
                  |
                  <a className="text-white" href="https://www.aeromexicorewards.com/mx/acerca-de-club-premier/aviso-de-privacidad/"> Aviso de Privacidad</a>
                </small>
              </Col>
            </Row>
          </Container>
        </Row>
      </div>
    </div>
  );
};

export default Footer;
